import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  ProductTierPriceRequest,
  ProductTierPriceResponse,
  TierPriceCalculateResponse
} from '../models/producto-tier-price.model';

@Injectable({
  providedIn: 'root'
})
export class ProductoTierPriceApiService {
  private readonly apiUrl = `${environment.apiUrl}api/products`;

  constructor(private http: HttpClient) { }

  getProductTierPrices(productId: number): Observable<ProductTierPriceResponse[]> {
    return this.http.get<ProductTierPriceResponse[]>(`${this.apiUrl}/${productId}/tier-prices`);
  }

  updateProductTierPrices(productId: number, businessId: number, tiers: ProductTierPriceRequest[]): Observable<ProductTierPriceResponse[]> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.put<ProductTierPriceResponse[]>(`${this.apiUrl}/${productId}/tier-prices`, tiers, { params });
  }

  deleteProductTierPrices(productId: number, businessId: number): Observable<void> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.delete<void>(`${this.apiUrl}/${productId}/tier-prices`, { params });
  }

  calculateProductTierPrice(productId: number, quantity: number): Observable<TierPriceCalculateResponse> {
    const params = new HttpParams().set('quantity', quantity.toString());
    return this.http.get<TierPriceCalculateResponse>(`${this.apiUrl}/${productId}/tier-prices/calculate`, { params });
  }
}
